import type { FilterConfigItemBasic } from '../../../../../../lib/api/filterConfig';
import { WorkspaceTypeID } from '../../../../../../lib/api/workspaces';
import extendDTCFilter from '../DTC/DTCFilterConfigMatcher';
import type { FilterConfigItem } from '../FilterConfigTypes';
import extendDefaultFilter from '../HCPExplorer/DefaultFilterConfigMatcher';
import extendListMatchingFilter from '../ListMatching/ListMatchingFilterConfigMatcher';
import extendThrotleFilter from '../Throtle/ThrotleFilterConfigMatcher';

const matchers: Partial<Record<WorkspaceTypeID, (filter: FilterConfigItemBasic) => FilterConfigItem>> = {
  [WorkspaceTypeID.Throtle]: extendThrotleFilter,
  [WorkspaceTypeID.HCPExplorer]: extendDefaultFilter,
  [WorkspaceTypeID.HCPExpansion]: extendDefaultFilter,
  [WorkspaceTypeID.ListMatching]: extendListMatchingFilter,
  [WorkspaceTypeID.DTC]: extendDTCFilter,
};

const extendFilterConfigs = (
  baseFilters: FilterConfigItemBasic[],
  workspaceTypeId: WorkspaceTypeID = WorkspaceTypeID.HCPExplorer,
) => {
  const extendFilter = matchers[workspaceTypeId] || extendDefaultFilter;
  const filtersWithCustomComponents = baseFilters.map(extendFilter);

  return filtersWithCustomComponents;
};

export { extendFilterConfigs };
